var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1354 25H2.86465C1.28441 25 0 23.7156 0 22.1354V2.86465C0 1.28441 1.28441 0 2.86465 0H22.1354C23.7156 0 25 1.28441 25 2.86465V22.1354C25 23.7156 23.7156 25 22.1354 25ZM2.86465 1.5625C2.14691 1.5625 1.5625 2.14691 1.5625 2.86465V22.1354C1.5625 22.8531 2.14691 23.4375 2.86465 23.4375H22.1354C22.8531 23.4375 23.4375 22.8531 23.4375 22.1354V2.86465C23.4375 2.14691 22.8531 1.5625 22.1354 1.5625H2.86465Z",
    fill: "#2A0C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1041 21.0938C14.3032 21.0938 13.6032 20.577 13.3595 19.8093L9.1053 5.65205C9.07917 5.5666 8.98857 5.46875 8.8541 5.46875C8.71983 5.46875 8.62923 5.5666 8.5989 5.66349L6.92596 11.2459C6.54793 12.4657 5.44472 13.2812 4.17709 13.2812H0.78125C0.349998 13.2812 0 12.9313 0 12.5C0 12.0687 0.349998 11.7188 0.78125 11.7188H4.17709C4.75521 11.7188 5.25837 11.3459 5.43022 10.7895L7.10526 5.2021C7.35321 4.42295 8.05321 3.90625 8.8541 3.90625C9.65519 3.90625 10.3552 4.42295 10.5989 5.19066L14.8531 19.348C14.8792 19.4334 14.9698 19.5312 15.1041 19.5312C15.2292 19.5312 15.3042 19.4584 15.3355 19.3895L18.0052 13.4115C18.4614 12.3844 19.4906 11.7188 20.6249 11.7188H24.2188C24.65 11.7188 25 12.0687 25 12.5C25 12.9313 24.65 13.2812 24.2188 13.2812H20.6249C20.1073 13.2812 19.6396 13.5822 19.4323 14.0469L16.7646 20.0167C16.4854 20.6667 15.8323 21.0938 15.1041 21.0938Z",
    fill: "#2A0C66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.4dc870ad888e3b8c83bd436a8d8f6c29.svg";
export { ForwardRef as ReactComponent };